import React from 'react';

import { useSearchParams } from 'react-router';

import { TAB_SEARCH_PARAM_KEY } from '@clearverify/constants';

import { TabItem } from 'src/components/common';

type Tabs<TabItemType> = [TabItem<TabItemType>, ...Array<TabItem<TabItemType>>];

export const useSearchParamsTabs = <TabItemType>(tabs: Tabs<TabItemType>) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const currentTabKey = searchParams.get(TAB_SEARCH_PARAM_KEY) || tabs[0].key;

  const handleTabChange = React.useCallback(
    (tabKey: TabItem['key']) => {
      setSearchParams({ [TAB_SEARCH_PARAM_KEY]: String(tabKey) }, { replace: false });
    },
    [setSearchParams],
  );

  return {
    currentTabKey,
    handleTabChange,
  };
};
